module.exports = {
	nav: {
		home: '首页',
		products: '产品',
		solutions: '解决方案',
		about: '关于我们',
		apply: '申 请 试 用',
		seeyi: '与Yi+一起看见非凡',
		watchVideo: '观看视频',
	},
	footer: {
		apply: '立 即 申 请',
		partnership: '合作',
		business: '商务',
		recruitment: '招聘',
		media: '媒体',
		more: '了解详情',
		products: '产品技术',
		solutions: '解决方案',
		about: '关于我们',
		follow: '关注我们',
		wechat: 'Yi+公众号',
		free:'多样化智能平台，一键免费申请',
		Moshanghua: '北京陌上花科技有限公司',
		ICP: '京ICP备15061733号-1',
	},
	home:{
		provide:'我们为众多公司提供了优质的服务',
		More:'进一步了解'
	},
	product: {
		Computer: '视觉搜索引擎',
		Depth: '商品深度建模搜索',
		depiction: '通过刻画高层语义特征和底层图像特征，加强了对相似商品的检索能力，基于电商大量商品数据，帮助用户快速找到感兴趣的商品。',
		Recommendation: '商品精准营销',
		behaviour: '通过对图像视频内容分析及用户行为刻画，实现商品精准推荐。',
		Analysis: '商品检测及类目分析',
		massive: '基于海量数据的深度学习，检测视频或图像中的商品，并通过商品特征分析，准确判断商品类目。支持服饰、3C数码、商超、家居、日用品、交通工具等超过100类商品的检测。',
		Image: '图像视频数据结构化引擎',
		Contour: '轮廓分割',
		characteristics: '通过对物体特征的学习，对视频和图像中的物体进行轮廓检测。',
		Target: '目标检测',
		adopts:'采用目前学界最领先的基于深度学习的通用目标检测算法，支持超过300类常用物体的目标检测、识别。',
		General: '通用物体和场景识别',
		supports: '通用物体和场景识别引擎支持大于万类通用物体和400类室内外场景的识别。',
		Face: '人脸识别与分析引擎',
		FaceRecognition: '人脸识别',
		RealTime: '可以在视频、图像中实现人脸实时检测，可用于相机、直播等多种场景。',
		Characteristic: '特征分析',
		identifies: '准确识别出照片中人物的性别、年龄、种族、情绪、颜值、性感、时尚等属性，平均准确率超过90%，\n' + '年龄预测平均误差小于3岁。',
		FaceComparison: '人脸比对',
		Facial: '基于深度学习的人脸对比技术，实现人脸相似度测量，可用于人脸聚类、敏感人物监控等场景。',
		Points: '关键点检测',
		Supports: '支持眼、嘴、鼻轮廓等200个人脸关键点的检测定位，可以适应表情动作变化。',
	},
	solution:{
		Excavating:'深耕智能媒介与营销流量入口创造',
		Industry:'Yi+AI 行业解决方案',
		Marketing:'营销+AI',
		Intelligent:'品效合一营销力赋予方案',
		Effective:'广告分发、内容智能推荐平台、场景化营销多样解决方案，与内容高度相关的广告曝光和内容推荐更为有效。',
		Relevant:'参考应用领域',
		Advertisers:'广告主',
		Advertising:'广告媒介',
		Video:'电脑、视频网站/APP',
		Livestream:'直播',
		Short:'短视频',
		Browsers:'浏览器',
		Search:'搜索引擎',
		Platforms:'图片平台',
		Structured:'图像视频数据结构化',
		Scenario:'场景化广告营销',
		ImageSearch:'图片商品同款搜索',
		SearchByImage:'以图搜图',
		Personalized:'信息流推荐',
		Face:'人脸识别广告',
		Television:'电视+AI',
		Communication:'智能传播力赋予方案',
		propelled:'人工智能时代的降临已经改变了电视的功能，更具多样播放功能力与营销能力的智能电视已经来临！',
		Smart:'智能电视',
		Assistant:'大屏观看AI助理',
		Televised:'大屏视频场景广告植入',
		Valueadded:'短视频智能生成',
		Extraction:'大屏实时直播增值服务',
		Broadcasting:'安全播控',
		CameraAi:'相机+AI',
		Creative:'创意交互力赋予方案',
		future:'无论是用来记录精彩瞬间还是作为输入工具，未来的更具有交互能力的相机大有作为!',
		Camera:'相机',
		Photo:'相册APP',
		SmartPhoto:'智搜相册',
		Virtual:'虚拟试妆',
		Dynamic:'动态AR相机',
		Shopping:'拍照购',
		Realtime:'场景物体实时识别',
	},
	about: {
		Intelligently:'智慧之眸',
		Extraordinary:'看见非凡',
		Contact:'联系我们',
		Join:'加入我们',
		intro: '"Yi+"（北京陌上花科技有限公司）是领先的计算机视觉引擎服务商，为企业提供视觉内容智能化和商业化解决方案。致力于"挖掘视觉信息的价值"。公司旗下品牌Yi+是人工智能计算机视觉引擎，衣+是时尚商品搜索引擎。\n' +
		'目前，Yi+以视频、图像中的人脸、物体、场景检测、识别、搜索、推荐技术的积累，布局在视频媒体、智能电视、智能相机、广播电视系统等领域，提供"电视+AI"、"相机+AI"及"营销+AI"的解决方案。 已通过基于视觉识别技术的数据结构化产品服务4亿用户，帮助媒体内容方实现智能分析、内容互动和场景营销。 ',
		media: '媒体报道',
		china: '中国（总部）',
		chinaAdds: '丹棱街6号中关村金融大厦',
		chinabeijing: '北京，海淀',
		USA:'美国',
		SINGAPORE: '新加坡',
	}
}


// WEBPACK FOOTER //
// ./src/i18n/lang/cn.js